export default __webpack_public_path__ + "static/media/prev-NavIC-Clock-3.340086f4.png";